import React from 'react'

function AboutIm() {
  return (
    <div className="about-iam">
      I'm a
    </div>
  )
}

export default AboutIm